import { createContext } from "react";

const userStateContext = createContext();
const userDispatchContext = createContext();

export { userStateContext, userDispatchContext };

